
namespace TabAurous.Production {
    @Serenity.Decorators.panel()

    @Serenity.Decorators.registerClass()
    export class ReceiptMaterialDialog extends _Ext.DialogBase<ReceiptMaterialRow, any> {
        protected getFormKey() { return ReceiptMaterialForm.formKey; }
        protected getIdProperty() { return ReceiptMaterialRow.idProperty; }
        protected getLocalTextPrefix() { return ReceiptMaterialRow.localTextPrefix; }
        protected getNameProperty() { return ReceiptMaterialRow.nameProperty; }
        protected getService() { return ReceiptMaterialService.baseUrl; }
        protected getDeletePermission() { return ReceiptMaterialRow.deletePermission; }
        protected getInsertPermission() { return ReceiptMaterialRow.insertPermission; }
        protected getUpdatePermission() { return ReceiptMaterialRow.updatePermission; }
        protected useViewMode() { return true; }

        public form = new ReceiptMaterialForm(this.idPrefix);
        constructor() {
            super();
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFullWidth(this.form.Details);
            q.hideEditorLabel(this.form.Details);
        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
            let self = this;


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };
 

            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            if (this.hasUpdatePermission) {
                let self = this;
                let refid: Stock.StockItemRow;
                //Stock.StockItemService.CheckTransaction(
                //    { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                //    response => {
                //        if (response.Entities != null && response.Entities.length > 0)
                //            refid = response.Entities[0];
                //    }, { async: false }
                //)
                if (refid != null) {
                    if (refid.PartyId != null || refid.PartyId > 0) {
                        q.Alert("Can not Edit!", "This Voucher has been used in transactions", 2500, false);
                        return;
                    }
                } else {
                    Serenity.EditorUtils.setReadonly(this.form.Details.element, false);
                    this.form.Details.Editable();
                    if (!self.isEditMode())
                        return;
                    self.editClicked = true;

                    self.updateInterface();
                    self.updateTitle();

                }
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            //Stock.StockItemService.CheckTransaction(
            //    { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
            //    response => {
            //        if (response.Entities != null && response.Entities.length > 0)
            //            refid = response.Entities[0];
            //    }, { async: false }
            //)
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    q.Alert("Can not Delete!", "This Voucher has been used in transactions", 2500, false);
                    return;
                }
            } else {

                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        ReceiptMaterialService.Delete(
                            {
                                EntityId: this.entityId
                            }, response => {
                                Serenity.SubDialogHelper.triggerDataChange(self);
                                self.dialogClose();
                                window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Deleted!',
                                        text: 'Voucher Deleted',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                );
                            }
                        );
                    }
                })
            }
        }
    }
}